export const shortenAddress = (address) => {
  if (!address) return '';
  return `${address.slice(0, 6)}...${address.slice(-4)}`;
};

export const formatNumber = (num, decimals = 4) => {
  if (num == null || Number.isNaN(num)) return '-';
  if (num === 0) return '0';
  
  const abs = Math.abs(num);
  
  // If >= 1 Sextillion, use abbreviation with letter
  if (abs >= 1e21) {
    return (num / 1e21).toFixed(2) + 'Sx';  // Sextillion
  }
  
  // If < 1 Sextillion, display full number with comma separator
  // Handle very small numbers
  if (abs < 0.0001) return num.toExponential(2);
  
  // Format with comma separator for numbers below sextillion
  const rounded = num.toFixed(decimals);
  const [integer, decimal] = rounded.split('.');
  const withCommas = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  
  return decimal ? `${withCommas}.${decimal}` : withCommas;
};

export const formatUsd = (num) => {
  if (num == null || Number.isNaN(num)) return '-';
  const n = Number(num);
  if (!Number.isFinite(n)) return '-';
  if (n === 0) return '$0';
  const abs = Math.abs(n);
  const sign = n < 0 ? '-' : '';
  if (abs < 0.001) return sign + '<$0.001';
  if (abs < 0.01) return sign + '$' + abs.toFixed(3);
  return sign + '$' + abs.toFixed(2);
};

export const formatPrice = (price) => {
  if (!price || price <= 0) return '--';
  if (price >= 1) return `$${price.toFixed(2)}`;
  if (price >= 0.01) return `$${price.toFixed(4)}`;
  return `$${price.toFixed(10)}`;
};

export const formatChange = (change) => {
  const v = Number(change || 0);
  const sign = v > 0 ? '+' : '';
  return `${sign}${v.toFixed(2)}%`;
};

export const trimZeros = (s) => {
  return String(s).replace(/(\. \d*?[1-9])0+$/, '$1').replace(/\.0+$/, '');
};

export const formatAmountForInput = (val, token, side) => {
  if (val == null || !Number.isFinite(val)) return '';
  const sym = (token?.symbol || '').toUpperCase();
  const isStable = sym === 'USDT' || sym === 'USDC';
  const isLRST = sym === 'LRST';
  if (isLRST) {
    if (val <= 0) return '0';
    return String(Math.floor(val));
  }
  if (isStable) {
    if (val === 0) return '0';
    if (val < 0.00001) return '<0.00001';
    return trimZeros(val.toFixed(5));
  }
  if (side === 'to') {
    if (sym === 'ETH' || sym === 'BNB' || sym === 'WBNB' || sym === 'BTCB') {
      return trimZeros(val.toFixed(val >= 1 ? 6 : 8));
    }
    if (val >= 1) return trimZeros(val.toFixed(0));
    return trimZeros(val.toFixed(8));
  }
  return trimZeros(val.toFixed(val >= 1 ? 6 : 8));
};

export const normalizeDecimalInput = (raw) => {
  if (raw == null) return '';
  let v = String(raw);
  v = v.replace(/\s+/g, '');
  v = v.replace(/,/g, '.');
  v = v.replace(/[^0-9.]/g, '');
  const firstDot = v.indexOf('.');
  if (firstDot !== -1) {
    const left = v.slice(0, firstDot + 1);
    const right = v.slice(firstDot + 1).replace(/\./g, '');
    v = left + right;
  }
  if (v.startsWith('.')) v = '0' + v;
  return v;
};
